<template>
  <div>
    <transition name="fade">
      <SGPModalComponent
        v-if="mostrarModal"
        :mostrarHeader="false"
        :mostrarFooter="false"
        mostrarBody
        tamanho="sm"
        titulo="Tem certeza disso?"
        @sgpModalFechar="cancelar"
      >
        <div class="sgp-confirmacao pl-3">
          <SGPRowComponent>
            <SGPColComponent cols="12">
              <span class="h5">Você tem certeza que deseja restaurar?</span>
            </SGPColComponent>

            <SGPColComponent cols="12">

              <div class="container-botoes">
                <SGPFormBotaoComponent
                  class=""
                  color="grey-5"
                  outlined
                  @click="cancelar()"
                  capitalize
                >
                  Cancelar
                </SGPFormBotaoComponent>
                <SGPFormBotaoComponent
                  color="primary"
                  @click="confirmar()"
                  capitalize
                >
                  Confirmar
                </SGPFormBotaoComponent>
              </div>

            </SGPColComponent>

          </SGPRowComponent>
        </div>
        
      </SGPModalComponent>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SGPConfirmacaoRestauracaoComponent',

  data () {
    return {
      mostrarModal: false
    }
  },

  emit: [
    // evento disparado com o clique do botão de cancelar
    'sgpCancelarRestauracaoEmit',
    // evento disparado com o clique do botão de confirmar
    'sgpConfirmarRestauracaoEmit'
  ],

  mounted () {
    this.mostrarModal = true
  },

  methods: {
    cancelar () {
      this.mostrarModal = false;
      setTimeout ( () => {
        this.$emit('sgpCancelarRestauracaoEmit');
      }, 100)
      
    },
    confirmar () {
      this.mostrarModal = false;
      this.$emit('sgpConfirmarRestauracaoEmit');
    },
  }
}
</script>